import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { useQuery } from 'react-apollo';
import brandQuery from './BrandQuery.gql';
import { config } from '../../../shop.config.custom';
import Image from '@jetshop/ui/Image/Image';
import { imageOverlay } from '../../CategoryPage/ProductCard';

const BrandWrapper = styled('div')`
  max-width: 100px;
  width: 100%;
  ${imageOverlay}
`;

export function imgUrl(subName) {
  return (
    '/pub_images/small/' +
    subName.replace(/[^a-z0-9]/gi, '_').toLowerCase() +
    '.png'
  );
}

export const Brand = ({ subName }) => {
  const result = useQuery(brandQuery, {
    variables: { id: config.routes.brand.id }
  });

  if (!subName || subName.length === 0) return null;

  const categories = result?.data?.category?.subcategories;

  const currentCategory =
    categories && categories.filter(cat => cat.name === subName)[0];

  const imgSrc = imgUrl(subName);

  return (
    <BrandWrapper>
      <>
        {currentCategory ? (
          <CategoryLink category={currentCategory}>
            <Image
              src={imgSrc}
              alt={subName}
              title={subName}
              aspect="2:1"
              sizes={[240]}
            />
          </CategoryLink>
        ) : (
          <Image
            src={imgSrc}
            alt={subName}
            title={subName}
            aspect="2:1"
            sizes={[240]}
          />
        )}
      </>
    </BrandWrapper>
  );
};
